<template>
  <FreeBottomSheet :name="name">
    <template #header="{ hide }">
      <FreeHeader class="p-4">
        <template #default>
          <h2 class="text-text-neutral-primary truncate text-base font-medium">
            {{ parsedUrl.pathname }}
          </h2>
        </template>
        <template #rightAction>
          <FreeCloseButton @click="hide" />
        </template>
      </FreeHeader>
    </template>
    <template #default>
      <div class="p-4">
        <div class="sticky top-0 h-0 w-full">
          <FreeButton
            size="sm"
            class="gray-button ml-auto"
            @click="onCopyLogData"
          >
            Copy
          </FreeButton>
        </div>
        <div class="space-y-4">
          <NetworkDetailBlock>
            <template #title>Method</template>
            <template #default>
              <span class="text-text-neutral-primary">
                {{ logData.request.method }}
              </span>
            </template>
          </NetworkDetailBlock>
          <NetworkDetailBlock>
            <template #title>Response Status Code</template>
            <template #default>
              <span class="text-text-neutral-primary">{{ statusText }}</span>
            </template>
          </NetworkDetailBlock>
          <NetworkDetailBlock>
            <template #title>URL</template>
            <template #default>
              <div class="text-text-neutral-primary">
                {{ parsedUrl.origin }}
              </div>
              <div class="text-text-neutral-primary">
                {{ parsedUrl.pathname }}{{ parsedUrl.search }}
              </div>
            </template>
          </NetworkDetailBlock>
          <NetworkDetailBlock v-if="parsedRequestBody">
            <template #title>Request Body</template>
            <template #default>
              <JsonViewer :value="parsedRequestBody" copyable boxed sort />
            </template>
          </NetworkDetailBlock>
          <NetworkDetailBlock>
            <template #title>Response Body</template>
            <JsonViewer
              v-if="parsedResponseBody"
              :value="parsedResponseBody"
              copyable
              boxed
              sort
            />
            <span v-else>Failed to load response data: no data found</span>
          </NetworkDetailBlock>
        </div>
      </div>
    </template>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  // @ts-expect-error No type declarations found
  import { JsonViewer } from 'vue3-json-viewer';
  // @ts-expect-error No type declarations found
  import { copyText } from '@aviata/copy-text';
  import { controllerModel } from 'shared';
  import {
    FreeBottomSheet,
    FreeButton,
    FreeCloseButton,
    FreeHeader,
  } from 'freedom-shared';
  import 'vue3-json-viewer/dist/index.css';

  import NetworkDetailBlock from './NetworkDetailBlock.vue';
  import type { NetworkLog } from '../../../entities/network-log';

  const props = defineProps<{ name: string }>();

  const bottomSheet = controllerModel.useBottomSheet();
  const logData = computed(
    () => bottomSheet.getParams(props.name).log as NetworkLog,
  );

  const parsedUrl = computed(() => new URL(logData.value.request.url));

  const statusText = computed(() => {
    const { status } = logData.value;

    if (status === 'PENDING') {
      return status;
    }

    return logData.value.response.status;
  });
  const parsedRequestBody = computed(
    () => logData.value.request.body && JSON.parse(logData.value.request.body),
  );
  const parsedResponseBody = computed(() => {
    if (logData.value.status === 'PENDING' || !logData.value.response.body) {
      return;
    }

    return JSON.parse(logData.value.response.body);
  });

  const onCopyLogData = () => {
    const data = JSON.stringify(logData.value);
    copyText(data);
  };
</script>
